const ENDPOIN = 'https://wallspy.online'
// const ENDPOIN = 'http://192.168.0.108:80'
const WS_ENDPOINT = 'wss://wallspy.online'
// const WS_ENDPOINT = 'ws://192.168.0.108:80'
export {ENDPOIN, WS_ENDPOINT}